// extracted by mini-css-extract-plugin
module.exports = {"container":"chats-layout_container__3GpHo"};